import React from "react"
import styled, { css } from "styled-components"
import { getMediaQueries } from "@abmg-components"

import TeamCard from "./team-card"

const { above } = getMediaQueries()
const size = {
  tablet: 950,
  break: 796,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const TeamContainer = styled.div`
  max-width: 1248px;
  margin: 0 auto;
  padding: 88px 48px;
  ${below.mobile`
  padding: 48px 24px;
  `}

  h2 {
    margin-bottom: 48px;
    ${below.tablet`
    font-size: 32px;
line-height: 40px;
margin-bottom:
  `};
  }
`
const FlexContainer = styled.div`
  // display: flex;
  // align-items: flex-start;
  // margin: 0;
  // justify-content: flex-start;
  // flex-wrap: wrap;
  display: grid;
  column-gap: 24px;
  row-gap: 48px;
  ${above.tablet`
    grid-template-columns: repeat(2, 1fr);
    justify-content: space-between;
  `}
`
const Column = styled.div`
  // flex: 1;
  width: 100%;
  ${above.tablet`
    // min-width:428px;
    max-width: 542px;
  `}// ${below.mobile`
  // min-width:unset;
  `} // &:first-child {
  //   margin-right: 12px;
  //   ${below.tablet`
  //   margin-right:0;
  //   `}
  //   ${below.break`margin: 0 6px;`}
  //   ${below.mobile`margin: 0;`}
  // }
  // &:last-child {
  //   margin-left: 12px;
  //   ${below.tablet`
  //   margin-left:0;
  //   `}
  //   ${below.break`margin: 0 6px;`}
  //   ${below.mobile`margin: 0;`}
  // }
`
const DummyCard = styled.div`
  flex: auto;
  padding-left: 12px;
  ${below.mobile`display: none;`}
`

const MBTeam = props => {
  const teammateCount = props.teammate ? props.teammate.length : 0

  return (
    <TeamContainer>
      <h2>Teamwork makes the dream work.</h2>
      <FlexContainer>
        {props.teammate.map(member => {
          return (
            <Column key={member.email}>
              <TeamCard
                email={member.email}
                title={member.title}
                nmls={member.nmls}
                fullname={member.fullname}
                phone={member.phone}
                headshot={member.headshot}
              />
            </Column>
          )
        })}
        {/* <Column>
          <TeamCard
            email={props.teammate[0].email}
            title={props.teammate[0].title}
            nmls={props.teammate[0].nmls}
            fullname={props.teammate[0].fullname}
            phone={props.teammate[0].phone}
            headshot={props.teammate[0].headshot}
          />
          {teammateCount > 2 ? (
            <TeamCard
              email={props.teammate[2].email}
              title={props.teammate[2].title}
              nmls={props.teammate[2].nmls}
              fullname={props.teammate[2].fullname}
              phone={props.teammate[2].phone}
              headshot={props.teammate[2].headshot}
            />
          ) : (
            <DummyCard />
          )}
        </Column>

        <Column>
          {teammateCount > 1 ? (
            <TeamCard
              email={props.teammate[1].email}
              title={props.teammate[1].title}
              nmls={props.teammate[1].nmls}
              fullname={props.teammate[1].fullname}
              phone={props.teammate[1].phone}
              headshot={props.teammate[1].headshot}
            />
          ) : (
            <DummyCard />
          )}
          {teammateCount > 3 ? (
            <TeamCard
              email={props.teammate[3].email}
              title={props.teammate[3].title}
              nmls={props.teammate[3].nmls}
              fullname={props.teammate[3].fullname}
              phone={props.teammate[3].phone}
              headshot={props.teammate[3].headshot}
            />
          ) : (
            <DummyCard />
          )}
        </Column> */}
      </FlexContainer>
    </TeamContainer>
  )
}

export default MBTeam
